import React from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@components/Button';

export interface RoutingCity {
  city_name: string;
  state_uf: string | null;
}

export interface RoutingCityDraft {
  name: string;
  uf: string;
}

interface RoutingCitiesEditorProps {
  cities: RoutingCity[];
  draft: RoutingCityDraft;
  onDraftChange: (draft: RoutingCityDraft) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  /** Texto de ajuda abaixo dos campos (varia por modo de roteamento). */
  help: React.ReactNode;
}

/** Chips de cidades permitidas + campos Cidade/UF (compartilhado pelos dois modos de roteamento). */
export const RoutingCitiesEditor: React.FC<RoutingCitiesEditorProps> = ({
  cities, draft, onDraftChange, onAdd, onRemove, help,
}) => (
  <div>
    <label className="block text-sm font-medium text-slate-700 mb-1">Cidades</label>
    {cities.length > 0 && (
      <div className="flex flex-wrap gap-2 mb-2">
        {cities.map((city, index) => (
          <span
            key={`${city.city_name}-${city.state_uf ?? ''}-${index}`}
            className="inline-flex items-center gap-1 rounded-full bg-slate-100 border border-slate-200 px-2.5 py-0.5 text-xs text-slate-700"
          >
            {city.city_name}{city.state_uf ? `/${city.state_uf}` : ''}
            <button
              className="text-slate-400 hover:text-red-600"
              onClick={() => onRemove(index)}
              aria-label={`Remover ${city.city_name}`}
            >
              <X size={12} />
            </button>
          </span>
        ))}
      </div>
    )}
    <div className="flex flex-wrap items-center gap-2">
      <input
        type="text"
        placeholder="Cidade"
        className="rounded-lg border border-slate-300 px-3 py-2 text-sm flex-1 min-w-[10rem]"
        value={draft.name}
        onChange={e => onDraftChange({ ...draft, name: e.target.value })}
        onKeyDown={e => { if (e.key === 'Enter') onAdd(); }}
      />
      <input
        type="text"
        placeholder="UF"
        maxLength={2}
        className="rounded-lg border border-slate-300 px-3 py-2 text-sm w-16 uppercase"
        value={draft.uf}
        onChange={e => onDraftChange({ ...draft, uf: e.target.value.toUpperCase() })}
        onKeyDown={e => { if (e.key === 'Enter') onAdd(); }}
      />
      <Button variant="outline" size="sm" onClick={onAdd} icon={<Plus size={14} />}>
        Adicionar
      </Button>
    </div>
    <div className="text-xs text-slate-500 mt-1">{help}</div>
  </div>
);
